import { FirebaseAudio } from "@components/FirebaseAudio";
import { useTranslatedKey } from "@helpers/useTranslatedKey";
import { FC } from "react";

type Props = {
  challenge: InfoChallenge;
};

/**
 * Guest view of an info challenge: a plain informational text page (typically opened via a
 * per-location QR-code deeplink), optionally with a playable sound file. There is nothing to
 * submit and it is never marked completed.
 */
export const Info: FC<Props> = ({ challenge }) => {
  const { getTranslatedValue } = useTranslatedKey();
  const title = getTranslatedValue(challenge, "title");
  const copy = getTranslatedValue(challenge, "copy");

  return (
    <div className="mt-4 mb-8 flex flex-col items-center">
      <h1 className="mx-4 mt-12 mb-8 text-center text-4xl font-semibold">{title}</h1>
      <div className="flex w-full max-w-lg flex-col justify-center px-6">
        <p className="text-md mt-4 mb-6 whitespace-pre-line text-center">{copy}</p>
        {challenge.audioUri && (
          <div className="mt-2 flex justify-center">
            <FirebaseAudio uri={challenge.audioUri} className="w-full" />
          </div>
        )}
      </div>
    </div>
  );
};
